<template>
  <div>
    <small>
      <a :href="$t('meter.moreInfoUrl')" data-cy="price-more-info-link" target="_blank">{{ $t('meter.moreInfo') }}</a>
      <template v-if="showGasFreeCondition">
        <br>* <span data-cy="gas-free-condition-link" v-html="$t('meter.gasFreeCondition')"></span>
      </template>
    </small>

    <div class="lib__feedback lib__feedback--alert">
      <div class="lib__feedback__icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="lib__feedback__content">
        <h3>{{ $t('meter.forInformationPrice') }}</h3>
        <p>{{ $t('meter.underReserveOfAvailability') }}</p>
        <p>{{ $t('meter.depthAnalysisForOffer') }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'price-annexe'
})
export default class PriceAnnexe extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: false, default: true }) public showGasFreeCondition!: boolean
  //#endregion
}
</script>